import React, { forwardRef, useImperativeHandle, useState } from "react";
import EdButton from "../../../generic/edButton";
import "../../../../assets/scss/components/clientarea/serviceRequest/serviceRequest.scss";
import "../../../../assets/scss/components/clientarea/serviceRequest/incomeDeclaration.scss";
import {
  CreateServiceRequest,
  GetCKYCValidation,
  GetAllNewExistingSRDetails,
  GetDepositoryDetails,
  getDPID,
  getMergeDocumentBase64,
  GetPersonDetails,
  ServiceClientValidation,
  createSRDocumentUpload,
} from "../../../service/serviceRequest/srApiService";
import InputField from "../../../generic/inputField";

import { IListObj } from "../../../types/genericTypes";
import TocDropdown from "../../../generic/tocDropdown";
import { useQuery } from "../../../service/urlHelper";
import { config } from "../../../../config/domain";
import Loader from "../../../generic/loader";
import { FileUploadSection } from "../../generic/fileUploadSection";
import {
  getAutoQc,
  getDocumentCategory,
  getMaskedAdhar,
  getOCRResp,
} from "../../generic/qCCheck";
import { checkPennyDrop } from "../../../service/generic/otherApi";
import { asyncGetServiceRequest } from "../../../service/postLogin/clientProfileAPIService";
import { KRADocumentUploadForm } from "../KRADocumentUpload/KRADocumentUpload";
//interface IHome { }
type TImageFile = {
  ImgCont: string;
  ImgNm: string;
  Type: string;
  fileIdName: string;
};
const addressProofOptions: Array<IListObj> = [
  { value: "Aadhar", display: "Aadhar card" },
  { value: "DrivingLicense", display: "Driving License" },
  { value: "NREGAJobCard", display: "NREGA job card" },
  { value: "Passport", display: "Passport" },
  { value: "VotersId", display: "Voters Id" },
];
const addressChildProofOptions: Array<IListObj> = [
  { value: "DrivingLicense", display: "Driving License" },
  { value: "NREGAJobCard", display: "NREGA job card" },
  { value: "Passport", display: "Passport" },
  { value: "VotersId", display: "Voters Id" },
];
const segincomeProof = [
  {
    display: "6 Months Bank Statement",
    value: "SixMonthsBankStatement",
    desc: "Latest self attested 6 months bank statement (not older than 3 months).  Bank statement should contain client's name, account number, period and bank's logo. If logo is not available then Bank's stamp & signature is required.",
  },
  {
    display: "ITR Proof",
    value: "ITRProof",
    desc: "Latest self attested ITR copy.",
  },
  {
    display: "Demat Holdings",
    value: "DematHoldings",
    desc: "Latest self attested demat holdings statement required. If, it is non-EBL DP then DP seal & signature is mandatory on the holding statement.",
  },
  {
    display: "Salary Slip",
    value: "SalarySlip",
    desc: "Latest self attested salary slip required. Name on salary slip should match with client's name and it should contain employer's logo. If employer's logo is not available then employer's stamp & HR signature is required.",
  },
  {
    display: "Net-worth Certificate",
    value: "NetworthCertificate",
    desc: "Self attested latest net - worth certificate with CA stamp & signature required.",
  },
];
var bankDropdownMenu: Array<any> = [
  {
    value: "BankStatement",
    display: "Bank Statement",
  },
  {
    value: "CancelledCheque",
    display: "Cancelled Cheque",
  },
];
var srIdList = {
  ckycId: "",
  // bankId: "",
  addressId: "",
  // bankQc: "",
  addressQc: "",
};
export const CKYCUpdate = forwardRef((props: any, ref: any) => {
  const source = useQuery().get("source");
  const addressConsent = useQuery().get("consent");
  const consentType = useQuery().get("consentType");
  const sr = useQuery().get("srID");
  const srID = sr;
  let accReact: any = localStorage.getItem("accReactParentDetails");
  accReact = accReact ? JSON.parse(accReact) : {};
  //const [loader, setLoader] = React.useState(true);
  const [personalDetails, setPersonalDetails] = React.useState<any>();
  const [profileFile, setProfileFile] = React.useState<any>();
  const [permantAddressFile, setPermantAddressFile] = React.useState<any>();
  const [permantAddressFile2, setPermantAddressFile2] = React.useState<any>();
  const [frontBack, setFrontBack] = React.useState(false);
  const [frontBackForCA, setFrontBackForCA] = React.useState(false);
  const [permantAddressProof, setPermantAddressProof] = React.useState<any>();
  const [correspondenceAddressFile, setCorrespondenceFile] =
    React.useState<any>();
  const [correspondenceAddressFile2, setcorrespondenceAddressFile2] =
    React.useState<any>();
  const [correspondenceAddressProof, setCorrespondenceAddressProof] =
    React.useState<any>();
  const [existingCKYCUpdateSR, setExistingCKYCUpdateSR] = React.useState("");
  const [dropValChangedForPA, setDropValChangedPA] = React.useState(false);
  const [dropValChangedForCA, setDropValChangedCA] = React.useState(false);
  const [dropValChangedForBank, setDropValChangedForBank] =
    React.useState(false);
  const [dropValChangedForIncome, setDropValChangedForIncome] =
    React.useState(false);
  const [enabledButton, setEnabledButton] = React.useState(false);
  const [selectedSegincomeProof, setSelectedSegincomeProof] =
    React.useState<any>();
  const [bankFile, setBankFile] = React.useState<any>();
  const [fullName, setFullName] = React.useState<any>();
  const [selectedincomeProof, setSelectedincomeProof] = React.useState<any>();
  const [incomeFile, setIncomeFile] = React.useState<any>({
    fileName: "",
    fileData: "",
  });
  const [childSr, setChildSr] = React.useState(
    props.childSr ? props.childSr : false
  );
  const [kraDetails, setKraDetails] = React.useState<any>({
    webSign: {},
    panCard: {},
    photo: {},
  });
  const [newDataPermanentAddress, setnewDataPermanentAddress] =
    React.useState<any>();
  const [newDataCorrespondeAddress, setNewCorrespondeAddressData] =
    React.useState<any>();
  const [accountCode, setAccountCode] = React.useState<any>();
  const [newDataBank, setNewBankData] = React.useState<any>();
  const [allBank, setAllBank] = React.useState<any>();
  const [showHide, setShowHide] = React.useState<any>({
    ckycStatus: true,
    //pennyDrop: true,
    is_digilocker_flow: true,
    showIncome: true,
    sameAsPermanent: false,
  });
  const [digDoc, setDigDoc] = useState<any>();
  const [photoDigiLoc, setPhotoDigiLoc] = React.useState<any>();
  const rejectFlow = window.location.href.includes("rejected");
  // const [srIdList, setsrIdList] = React.useState<any>({
  //   ckycId: "",
  //   bankId: "",
  //   addressId: "",
  // });

  React.useEffect(() => {
    setPermantAddressProof(
      childSr ? addressChildProofOptions[0].value : addressProofOptions[0].value
    );
    setCorrespondenceAddressProof(
      childSr ? addressChildProofOptions[0].value : addressProofOptions[0].value
    );
    // if (accReactDetails.ckycStatus) {
    //   setProfileFile({ fileName: "", fileData: "" });
    // }
    // if (accReactDetails.pennyDrop) {
    //   setBankFile({ fileName: "", fileData: "" });
    // }
    // if (accReactDetails.is_digilocker_flow) {
    //   setPermantAddressFile({ fileName: "", fileData: "" });
    //   setCorrespondenceFile({ fileName: "", fileData: "" });
    // }
    // setLoader(false);
    if (!childSr) {
      getPersonDetail();
      if (srID) {
        getExistingDocuments(srID);
      } else {
        checkCKYCValidation();
      }
    } else {
      props.setLoader(true);
      asyncGetServiceRequest(props.srId)
        .then((list) => {
          FlowSet(list);
        })
        .catch((err) => {
          apiError();
        });
      setSelectedSegincomeProof(bankDropdownMenu[0].value);
      setSelectedincomeProof(segincomeProof[0].value);
      props.showFooter(false);
    }
  }, []);
  async function getExistingDocuments(srId: any) {
    props.setLoader(true);
    try {
      let { result: resp } = await GetAllNewExistingSRDetails(srId);
      if (resp && resp.new_data) {
        // let documents = resp.documents;
        // const profile = documents.find(
        //   (doc: any) => doc.documentTypeName === "ProfilePhoto"
        // );
        // if (profile)
        //   setProfileFile({
        //     fileName: profile.fileName,
        //     fileData: profile.fileData,
        //   });
        // else setProfileFile({ fileName: "", fileData: "" });
        // const address = documents.filter(
        //   (doc: any) =>
        //     doc.documentTypeName === "Aadhar" ||
        //     doc.documentTypeName === "VotersId" ||
        //     doc.documentTypeName === "Passport" ||
        //     doc.documentTypeName === "NREGAJobCard" ||
        //     doc.documentTypeName === "DrivingLicense"
        // );
        if (
          JSON.stringify(resp.new_data.newCorrespondenceAdr) ===
          JSON.stringify(resp.new_data.newPermanentAdr)
        ) {
          setShowHide({
            ...showHide,
            is_digilocker_flow: false,
            sameAsPermanent: true,
          });
          // if (address) {
          //   setPermantAddressFile({
          //     fileName: address[0].fileName,
          //     fileData: address[0].fileData,
          //   });
          //   setPermantAddressProof(address[0].documentTypeName);
          // }
          setCorrespondenceFile({ fileName: "", fileData: "" });
        } else {
          setShowHide({
            ...showHide,
            is_digilocker_flow: false,
            sameAsPermanent: false,
          });
          // if (address) {
          //   setPermantAddressFile({
          //     fileName: address[0].fileName,
          //     fileData: address[0].fileData,
          //   });
          //   setCorrespondenceAddressProof(address[1].documentTypeName);
          //   setCorrespondenceFile({
          //     fileName: address[1].fileName,
          //     fileData: address[1].fileData,
          //   });
          //   setPermantAddressProof(address[0].documentTypeName);
          // }
        }
        props.setLoader(false);
        props.showFooter(true);
      } else {
        apiError();
      }
    } catch (error) {
      apiError();
    }
  }

  const FlowSet = async (childSrList: any) => {
    try {
      if (childSrList && childSrList.length > 0) {
        const showHideStatus: any = showHide;
        accReact.is_digilocker_flow = childSrList.find(
          (list: any) => list.RequestType === "Change of Address"
        )?.is_digilocker_flow
          ? true
          : false;
        await Promise.all(
          childSrList.map(async (srList: any) => {
            if (rejectFlow) {
              if (srList.RequestType === "CKYC Update") {
                if (srList.RequestStatus === "Rejected - Resubmit") {
                  srIdList.ckycId = srList.RequestId;
                  showHideStatus.is_digilocker_flow = false;
                  showHideStatus.ckycStatus = false;
                  showHideStatus.sameAsPermanent = await getNewSrData(
                    // Number(srList.RequestId),
                    Number(props.srId), // for getting address details
                    "CKYC"
                  );
                }
              } else if (srList.RequestType === "Change of Address") {
                if (srList.RequestStatus === "Rejected - Resubmit") {
                  srIdList.addressId = srList.RequestId;
                  showHideStatus.is_digilocker_flow = false;
                  showHideStatus.sameAsPermanent = await getNewSrData(
                    Number(srList.RequestId),
                    "Address"
                  );
                }
                if (showHideStatus.ckycStatus) {
                  showHideStatus.is_digilocker_flow = true;
                  setPermantAddressFile({ fileName: "", fileData: "" });
                  setCorrespondenceFile({ fileName: "", fileData: "" });
                }

                if (
                  srList.RequestStatus === "Resubmitted" &&
                  accReact.is_digilocker_flow
                ) {
                  srIdList.addressId = srList.RequestId;
                  showHideStatus.is_digilocker_flow = true;
                  setPermantAddressFile({ fileName: "", fileData: "" });
                  setCorrespondenceFile({ fileName: "", fileData: "" });
                }
              }
              // else if (srList.RequestType === "Bank Modification") {
              //   if (srList.RequestStatus === "Rejected - Resubmit") {
              //     srIdList.bankId = srList.RequestId;
              //     //showHideStatus.pennyDrop = false;
              //     showHideStatus.pennyDrop = await getNewSrData(
              //       Number(srList.RequestId),
              //       "Bank"
              //     );
              //   } else {
              //     //showHideStatus.pennyDrop = true;
              //    // setBankFile({ fileName: "", fileData: "" });
              //   }
              // }
            } else {
              if (
                srList.RequestType === "CKYC Update" &&
                accReact.is_digilocker_flow
              ) {
                srIdList.ckycId = srList.RequestId;
                showHideStatus.ckycStatus = false;
                showHideStatus.is_digilocker_flow = true;
                setPermantAddressFile({ fileName: "", fileData: "" });
                setCorrespondenceFile({ fileName: "", fileData: "" });
              } else if (
                srList.RequestType === "CKYC Update" &&
                !accReact.is_digilocker_flow
              ) {
                showHideStatus.ckycStatus = false;
                srIdList.ckycId = srList.RequestId;
                showHideStatus.is_digilocker_flow = false;
              }
              // else if (srList.RequestType === "Bank Modification") {
              //   srIdList.bankId = srList.RequestId;
              //   showHideStatus.pennyDrop = await getNewSrData(
              //     Number(srList.RequestId),
              //     "Bank"
              //   );
              // }
              else if (srList.RequestType === "Change of Address") {
                srIdList.addressId = srList.RequestId;
                showHideStatus.is_digilocker_flow = srList.is_digilocker_flow;
                showHideStatus.sameAsPermanent = await getNewSrData(
                  Number(srList.RequestId),
                  "Address"
                );
              }
            }
          })
        );
        // if (!rejectFlow) {
        //   if (showHideStatus.ckycStatus && accReact.is_digilocker_flow) {
        //     showHideStatus.is_digilocker_flow = true;
        //     setProfileFile({ fileName: "", fileData: "" });
        //     setPermantAddressFile({ fileName: "", fileData: "" });
        //     setCorrespondenceFile({ fileName: "", fileData: "" });
        //   }
        //   if (showHideStatus.ckycStatus && accReact.is_digilocker_flow) {
        //     showHideStatus.is_digilocker_flow = false;
        //     //setProfileFile({ fileName: "", fileData: "" });
        //     setPermantAddressFile({ fileName: "", fileData: "" });
        //     setCorrespondenceFile({ fileName: "", fileData: "" });
        //   }
        // }
        // if (showHideStatus.pennyDrop) {
        //   setBankFile({
        //     fileName: "",
        //     fileData: "",
        //   });
        // }
        if (showHideStatus.ckycStatus) {
          setProfileFile({ fileName: "", fileData: "" });
        }
        if (showHideStatus.is_digilocker_flow) {
          setPermantAddressFile({ fileName: "", fileData: "" });
          setCorrespondenceFile({ fileName: "", fileData: "" });
        }
        if (
          showHideStatus.ckycStatus &&
          //showHideStatus.pennyDrop &&
          showHideStatus.is_digilocker_flow &&
          showHideStatus.showIncome
        ) {
          if (rejectFlow) {
            if (!srIdList.addressId) {
              props.next();
            }
          } else {
            if (!srIdList.addressId) {
              submitRequest();
            }
          }
        }
        console.log(showHideStatus);

        setShowHide({ ...showHideStatus });
      }

      props.setLoader(false);
    } catch (error) {
      console.log(error);

      props.setLoader(false);
      apiError();
    }
  };

  const getNewSrData = async (id: Number, type: string) => {
    try {
      const { result: newDataRes } = await GetAllNewExistingSRDetails(id);
      if (newDataRes && newDataRes.old_data) {
        setAccountCode(
          newDataRes.old_data.accountcode
            ? newDataRes.old_data.accountcode
            : undefined
        );
      }
      if (newDataRes && newDataRes.documents && newDataRes.documents.length > 0)
        newDataRes.documents.map((item: any) => {
          if (item.documentTypeName === "Aadhar") {
            setDigDoc({
              documentTypeName: item.documentTypeName,
              fileData: item.fileData,
              fileName: item.fileName,
            });
          } else if (item.documentTypeName === "ProfilePhoto") {
            setPhotoDigiLoc({
              documentTypeName: item.documentTypeName,
              fileData: item.fileData,
              fileName: item.fileName,
            });
          }
        });

      if (newDataRes && newDataRes.new_data) {
        // if (type === "Bank") {
        //   if (
        //     newDataRes.new_data.bankAccountChangeDetails &&
        //     newDataRes.new_data.bankAccountChangeDetails.length > 0
        //   ) {
        //     setAllBank(newDataRes.new_data.bankAccountChangeDetails);
        //     const newBank: any =
        //       newDataRes.new_data.bankAccountChangeDetails.find(
        //         (bank: any) => bank.new_bank_details === "Yes"
        //       );
        //     // const defaultBank =
        //     //   newDataRes.new_data.bankAccountChangeDetails.find(
        //     //     (bank: any) => bank.default_account_flag
        //     //   );
        //     if (newBank) {
        //       // const bank = newBank ? newBank : defaultBank;
        //       setNewBankData(newBank);
        //       if (newBank.penny_drop === "Yes") {
        //         setBankFile({ fileName: "", fileData: "" });
        //         return true;
        //       }
        //       // else {
        //       //   const bankFile = newDataRes?.documents?.find(
        //       //     (doc: any) =>
        //       //       doc.documentTypeName === "CancelledCheque" ||
        //       //       doc.documentTypeName === "BankStatement"
        //       //   );
        //       //   if (bankFile) {
        //       //     setBankFile({
        //       //       fileName: bankFile.fileName,
        //       //       fileData: bankFile.fileData,
        //       //     });
        //       //     setDropValChangedForBank(bankFile.documentTypeName);
        //       //   }
        //       // }
        //     } else {
        //       if (newDataRes.new_data.bank_identify_changes === "Interchange") {
        //         setNewBankData(
        //           newDataRes.new_data.bankAccountChangeDetails.find(
        //             (bank: any) => bank.default_account_flag
        //           )
        //         );
        //         return false;
        //       }
        //       setBankFile({ fileName: "", fileData: "" });
        //       return true;
        //     }
        //   }
        // } else
        if (type === "Address") {
          if (newDataRes.old_data && newDataRes.old_data.fullAcName)
            setFullName(newDataRes.old_data.fullAcName);
          if (newDataRes.new_data.newPermanentAdr) {
            setnewDataPermanentAddress(newDataRes.new_data.newPermanentAdr);
          }
          if (newDataRes.new_data.newCorrespondenceAdr) {
            setNewCorrespondeAddressData(
              newDataRes.new_data.newCorrespondenceAdr
            );
            // console.log(
            //   newDataRes.new_data.newCorrespondenceAdr,
            //   newDataRes.new_data.newPermanentAdr
            // );
            const address = newDataRes?.documents?.filter(
              (doc: any) =>
                doc.documentTypeName === "Aadhar" ||
                doc.documentTypeName === "VotersId" ||
                doc.documentTypeName === "Passport" ||
                doc.documentTypeName === "NREGAJobCard" ||
                doc.documentTypeName === "DrivingLicense"
            );
            if (
              JSON.stringify(newDataRes.new_data.newCorrespondenceAdr) ===
              JSON.stringify(newDataRes.new_data.newPermanentAdr)
            ) {
              setCorrespondenceFile({ fileName: "", fileData: "" });
              // if (address) {
              //   setPermantAddressFile({
              //     fileName: address[0].fileName,
              //     fileData: address[0].fileData,
              //   });
              //   setPermantAddressProof(address[0].documentTypeName);
              // }
              if (showHide.ckycStatus) {
                setProfileFile({ fileName: "", fileData: "" });
              }

              return true;
            } else {
              // if (address) {
              //   setPermantAddressFile({
              //     fileName: address[0].fileName,
              //     fileData: address[0].fileData,
              //   });
              //   setCorrespondenceAddressProof(
              //     address[1] && address[1].documentTypeName
              //       ? address[1].documentTypeName
              //       : addressProofOptions[0].value
              //   );
              //   setCorrespondenceFile({
              //     fileName:
              //       address[1] && address[1].fileName
              //         ? address[1].fileName
              //         : "",
              //     fileData:
              //       address[1] && address[1].fileData
              //         ? address[1].fileData
              //         : "",
              //   });
              //   setPermantAddressProof(address[0].documentTypeName);
              // }
              if (showHide.ckycStatus) {
                setProfileFile({ fileName: "", fileData: "" });
              }
            }
          }
        } else if (type === "CKYC") {
          // const profile = newDataRes?.documents?.find(
          //   (doc: any) => doc.documentTypeName === "ProfilePhoto"
          // );
          // if (profile)
          //   setProfileFile({
          //     fileName: profile.fileName,
          //     fileData: profile.fileData,
          //   });
          // else
          setProfileFile({ fileName: "", fileData: "" });

          // if user skip address it will get from old_data
          const corAddress = newDataRes.new_data.newCorrespondenceAdr
            ? newDataRes.new_data.newCorrespondenceAdr
            : newDataRes.old_data.correspondenceAddress[0];
          const parAddress = newDataRes.new_data.newPermanentAdr
            ? newDataRes.new_data.newPermanentAdr
            : newDataRes.old_data.permanentAddress[0];

          if (JSON.stringify(corAddress) === JSON.stringify(parAddress)) {
            setCorrespondenceFile({ fileName: "", fileData: "" });
            return true;
          }
        }
      }
      return false;
    } catch (err) {
      apiError();
    }
  };

  async function getAutoQCDetails() {
    // if (selectedSegincomeProof === "CancelledCheque" && !showHide.pennyDrop) {
    //   let requestObj = {
    //     applicationid: accountCode,
    //     base64document: bankFile.fileData,
    //     documentcategory: "Cheque",
    //     documentid: 117,
    //     source: "DIY",
    //   };
    //   // console.log(requestObj);

    //   try {
    //     let autoQc = await getAutoQc(requestObj, {
    //       accNo: newDataBank.account_number,
    //       ifsc: newDataBank.ifsc_Code,
    //       bankName: newDataBank.bank_name,
    //       micr: newDataBank.micr_code,
    //     });
    //     srIdList.bankQc = autoQc;
    //   } catch (error) {
    //     //console.log(error);
    //     apiError();
    //   }
    // } else {
    //   srIdList.bankQc = "No";
    // }
    let autoQc1 = "",
      autoQC2 = "";
    //console.log(permantAddressFile);

    if (
      permantAddressProof !== "NREGAJobCard" &&
      permantAddressFile &&
      permantAddressFile.fileData
    ) {
      let documentCategory = { name: "", id: 0 };
      documentCategory = getDocumentCategory(
        permantAddressProof,
        documentCategory
      );
      let requestPayload = {
        applicationid: accountCode,
        base64document: permantAddressFile.fileData,
        documentcategory: documentCategory.name,
        documentid: documentCategory.id,
        source: "DIY",
      };
      try {
        let ocrResp: any;
        ocrResp = await getOCRResp(documentCategory.name, requestPayload);

        if (
          ocrResp.data.status === "completed" &&
          ocrResp.data.result.extraction_output
        ) {
          let result = ocrResp.data.result.extraction_output;
          let finalAddress =
            newDataPermanentAddress.address_line_1 +
            newDataPermanentAddress.address_line_2 +
            newDataPermanentAddress.state +
            newDataPermanentAddress.pincode;
          if (
            result.address.toLowerCase() === finalAddress.toLowerCase() &&
            fullName &&
            result.name_on_card.toLowerCase() === fullName.toLowerCase()
          ) {
            autoQc1 = "Yes";
          } else {
            autoQc1 = "No";
          }
        } else {
          autoQc1 = "No";
        }
      } catch (error) {
        autoQc1 = "No";
      }
    }
    if (
      correspondenceAddressProof !== "NREGAJobCard" &&
      correspondenceAddressFile &&
      correspondenceAddressFile.fileData
    ) {
      let documentCategory = { name: "", id: 0 };
      documentCategory = getDocumentCategory(
        correspondenceAddressProof,
        documentCategory
      );
      let requestPayload = {
        applicationid: accountCode,
        base64document: correspondenceAddressFile.fileData,
        documentcategory: documentCategory.name,
        documentid: documentCategory.id,
        source: "DIY",
      };
      try {
        let ocrResp: any;
        ocrResp = await getOCRResp(documentCategory.name, requestPayload);
        if (
          ocrResp.data.status === "completed" &&
          ocrResp.data.result.extraction_output
        ) {
          let result = ocrResp.data.result.extraction_output;
          let finalAddress =
            newDataCorrespondeAddress.address_line_1 +
            newDataCorrespondeAddress.address_line_2 +
            newDataCorrespondeAddress.state +
            newDataCorrespondeAddress.pincode;
          if (
            result.address.toLowerCase() === finalAddress.toLowerCase() &&
            fullName &&
            result.name_on_card.toLowerCase() === fullName.toLowerCase()
          ) {
            autoQC2 = "Yes";
          } else {
            autoQC2 = "No";
          }
        } else {
          autoQC2 = "No";
        }
      } catch (error) {
        autoQC2 = "No";
      }
    }
    if (autoQc1 === "Yes" && (autoQC2 === "Yes" || autoQC2 === "")) {
      srIdList.addressQc = "Yes";
    } else {
      srIdList.addressQc = "No";
    }
  }

  const toCamelCase = (string: any) => {
    return string.replace(/\w\S*/g, function (txt: any) {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
  };
  async function getPersonDetail() {
    props.setLoader(true);
    try {
      let resp = await GetPersonDetails();
      if (resp) {
        setPersonalDetails({
          accountCodeField: resp.accountCodeField ? resp.accountCodeField : "",
          pANNumberField: resp.pANNumberField ? resp.pANNumberField : "",
          addressField: resp.addressField
            ? toCamelCase(resp.addressField.toLowerCase())
            : "",
          currentAddressField: resp.currentAddressField
            ? toCamelCase(resp.currentAddressField.toLowerCase())
            : "",
        });
        if (
          resp.addressField &&
          resp.currentAddressField &&
          resp.addressField.match(resp.currentAddressField)
        ) {
          setShowHide({
            ...showHide,
            is_digilocker_flow: false,
            sameAsPermanent: true,
          });
          setCorrespondenceFile({ fileName: "", fileData: "" });
        } else {
          if (
            resp.addressField &&
            resp.currentAddressField &&
            resp.addressField.match(resp.currentAddressField)
          ) {
            setShowHide({
              ...showHide,
              is_digilocker_flow: false,
              sameAsPermanent: false,
            });
          }
        }
        // console.log(typeof resp.addressField);
        // console.log(typeof resp.currentAddressField);
      } else {
        props.setLoader(false);
      }
    } catch (error) {
      //console.log(error);
      apiError();
    }
  }
  React.useEffect(() => {
    if (
      permantAddressFile2 &&
      permantAddressFile2.fileName &&
      permantAddressFile2.fileData
    ) {
      if (
        !(
          profileFile &&
          permantAddressFile &&
          permantAddressFile2 &&
          permantAddressProof &&
          correspondenceAddressFile &&
          correspondenceAddressProof
        )
      ) {
        props.enableSubmit(false);
      } else {
        if (!childSr) props.enableSubmit(true);
        else {
          if (
            !(
              profileFile &&
              permantAddressFile &&
              permantAddressFile2 &&
              permantAddressProof &&
              correspondenceAddressFile &&
              correspondenceAddressProof &&
              isKraDetails() &&
              //bankFile &&
              incomeFile &&
              selectedSegincomeProof &&
              selectedincomeProof
            )
          ) {
            setEnabledButton(false);
          } else {
            setEnabledButton(true);
          }
        }
      }
    } else {
      setPermantAddressFile2(undefined);
    }
  }, [permantAddressFile2]);

  React.useEffect(() => {
    if (
      correspondenceAddressFile2 &&
      correspondenceAddressFile2.fileName &&
      correspondenceAddressFile2.fileData
    ) {
      if (
        !(
          profileFile &&
          permantAddressFile &&
          permantAddressProof &&
          correspondenceAddressFile &&
          correspondenceAddressFile2 &&
          correspondenceAddressProof
        )
      ) {
        props.enableSubmit(false);
      } else {
        if (!childSr) props.enableSubmit(true);
        else {
          if (
            !(
              profileFile &&
              permantAddressFile &&
              permantAddressProof &&
              correspondenceAddressFile &&
              correspondenceAddressFile2 &&
              correspondenceAddressProof &&
              isKraDetails() &&
              //bankFile &&
              incomeFile &&
              selectedSegincomeProof &&
              selectedincomeProof
            )
          ) {
            setEnabledButton(false);
          } else {
            setEnabledButton(true);
          }
        }
      }
    } else {
      setcorrespondenceAddressFile2(undefined);
    }
  }, [correspondenceAddressFile2]);

  React.useEffect(() => {
    if (frontBack) {
      if (
        !(
          profileFile &&
          permantAddressFile &&
          permantAddressFile2 &&
          permantAddressProof &&
          correspondenceAddressFile &&
          correspondenceAddressProof
        )
      ) {
        if (!childSr) props.enableSubmit(false);
        else {
          if (
            !(
              profileFile &&
              permantAddressFile &&
              permantAddressFile2 &&
              permantAddressProof &&
              correspondenceAddressFile &&
              correspondenceAddressProof &&
              isKraDetails() &&
              //bankFile &&
              incomeFile &&
              selectedSegincomeProof &&
              selectedincomeProof
            )
          ) {
            setEnabledButton(false);
          } else {
            setEnabledButton(true);
          }
        }
      } else {
        if (!childSr) props.enableSubmit(true);
        else {
          if (
            !(
              profileFile &&
              permantAddressFile &&
              permantAddressFile2 &&
              permantAddressProof &&
              correspondenceAddressFile &&
              correspondenceAddressProof &&
              isKraDetails() &&
              //bankFile &&
              incomeFile &&
              selectedSegincomeProof &&
              selectedincomeProof
            )
          ) {
            setEnabledButton(false);
          } else {
            setEnabledButton(true);
          }
        }
      }
    }
    if (frontBackForCA) {
      if (
        !(
          profileFile &&
          permantAddressFile &&
          permantAddressProof &&
          correspondenceAddressFile &&
          correspondenceAddressFile2 &&
          correspondenceAddressProof
        )
      ) {
        if (!childSr) props.enableSubmit(false);
        else {
          if (
            !(
              profileFile &&
              permantAddressFile &&
              permantAddressProof &&
              correspondenceAddressFile &&
              correspondenceAddressFile2 &&
              correspondenceAddressProof &&
              isKraDetails() &&
              //bankFile &&
              incomeFile &&
              selectedSegincomeProof &&
              selectedincomeProof
            )
          ) {
            setEnabledButton(false);
          } else {
            setEnabledButton(true);
          }
        }
      } else {
        if (!childSr) props.enableSubmit(true);
        else {
          if (
            !(
              profileFile &&
              permantAddressFile &&
              permantAddressProof &&
              correspondenceAddressFile &&
              correspondenceAddressFile2 &&
              correspondenceAddressProof &&
              isKraDetails() &&
              //bankFile &&
              incomeFile &&
              selectedSegincomeProof &&
              selectedincomeProof
            )
          ) {
            setEnabledButton(false);
          } else {
            setEnabledButton(true);
          }
        }
      }
    }
    if (frontBack && frontBackForCA) {
      if (
        !(
          profileFile &&
          permantAddressFile &&
          permantAddressFile2 &&
          permantAddressProof &&
          correspondenceAddressFile &&
          correspondenceAddressFile2 &&
          correspondenceAddressProof
        )
      ) {
        if (!childSr) props.enableSubmit(false);
        else {
          if (
            !(
              profileFile &&
              permantAddressFile &&
              permantAddressFile2 &&
              permantAddressProof &&
              correspondenceAddressFile &&
              correspondenceAddressFile2 &&
              correspondenceAddressProof &&
              isKraDetails() &&
              //bankFile &&
              incomeFile &&
              selectedSegincomeProof &&
              selectedincomeProof
            )
          ) {
            setEnabledButton(false);
          } else {
            setEnabledButton(true);
          }
        }
      } else {
        if (!childSr) props.enableSubmit(true);
        else {
          if (
            !(
              profileFile &&
              permantAddressFile &&
              permantAddressFile2 &&
              permantAddressProof &&
              correspondenceAddressFile &&
              correspondenceAddressFile2 &&
              correspondenceAddressProof &&
              isKraDetails() &&
              //bankFile &&
              incomeFile &&
              selectedSegincomeProof &&
              selectedincomeProof
            )
          ) {
            setEnabledButton(false);
          } else {
            setEnabledButton(true);
          }
        }
      }
    }
  }, [frontBack, frontBackForCA]);
  React.useEffect(() => {
    if (!frontBack) {
      if (frontBackForCA) {
        if (
          !(
            profileFile &&
            permantAddressFile &&
            permantAddressProof &&
            correspondenceAddressFile &&
            correspondenceAddressFile2 &&
            correspondenceAddressProof
          )
        ) {
          if (!childSr) props.enableSubmit(false);
          else {
            if (
              !(
                profileFile &&
                permantAddressFile &&
                permantAddressProof &&
                correspondenceAddressFile &&
                correspondenceAddressFile2 &&
                correspondenceAddressProof &&
                isKraDetails() &&
                //bankFile &&
                incomeFile &&
                selectedSegincomeProof &&
                selectedincomeProof
              )
            ) {
              setEnabledButton(false);
            } else {
              setEnabledButton(true);
            }
          }
        } else {
          if (!childSr) props.enableSubmit(true);
          else {
            if (
              !(
                profileFile &&
                permantAddressFile &&
                permantAddressProof &&
                correspondenceAddressFile &&
                correspondenceAddressFile2 &&
                correspondenceAddressProof &&
                isKraDetails() &&
                //bankFile &&
                incomeFile &&
                selectedSegincomeProof &&
                selectedincomeProof
              )
            ) {
              setEnabledButton(false);
            } else {
              setEnabledButton(true);
            }
          }
        }
      } else {
        if (!childSr) {
          if (
            !(
              profileFile &&
              permantAddressFile &&
              permantAddressProof &&
              correspondenceAddressFile &&
              correspondenceAddressProof
            )
          ) {
            props.enableSubmit(false);
          } else {
            props.enableSubmit(true);
          }
        } else {
          if (
            !(
              profileFile &&
              permantAddressFile &&
              permantAddressProof &&
              correspondenceAddressFile &&
              correspondenceAddressProof &&
              isKraDetails() &&
              //bankFile &&
              incomeFile &&
              selectedSegincomeProof &&
              selectedincomeProof
            )
          ) {
            setEnabledButton(false);
          } else {
            setEnabledButton(true);
          }
        }
      }
    }
  }, [frontBack]);
  React.useEffect(() => {
    if (!frontBackForCA) {
      if (frontBack) {
        if (
          !(
            profileFile &&
            permantAddressFile &&
            permantAddressFile2 &&
            permantAddressProof &&
            correspondenceAddressFile &&
            correspondenceAddressProof
          )
        ) {
          if (!childSr) props.enableSubmit(false);
          else {
            if (
              !(
                profileFile &&
                permantAddressFile &&
                permantAddressFile2 &&
                permantAddressProof &&
                correspondenceAddressFile &&
                correspondenceAddressProof &&
                isKraDetails() &&
                //bankFile &&
                incomeFile &&
                selectedSegincomeProof &&
                selectedincomeProof
              )
            ) {
              setEnabledButton(false);
            } else {
              setEnabledButton(true);
            }
          }
        } else {
          if (!childSr) props.enableSubmit(true);
          else {
            if (
              !(
                profileFile &&
                permantAddressFile &&
                permantAddressFile2 &&
                permantAddressProof &&
                correspondenceAddressFile &&
                correspondenceAddressProof &&
                isKraDetails() &&
                //bankFile &&
                incomeFile &&
                selectedSegincomeProof &&
                selectedincomeProof
              )
            ) {
              setEnabledButton(false);
            } else {
              setEnabledButton(true);
            }
          }
        }
      } else {
        if (!childSr) {
          if (
            !(
              profileFile &&
              permantAddressFile &&
              permantAddressProof &&
              correspondenceAddressFile &&
              correspondenceAddressProof
            )
          ) {
            props.enableSubmit(false);
          } else {
            props.enableSubmit(true);
          }
        } else {
          if (
            !(
              profileFile &&
              permantAddressFile &&
              permantAddressProof &&
              correspondenceAddressFile &&
              correspondenceAddressProof &&
              isKraDetails() &&
              //bankFile &&
              incomeFile &&
              selectedSegincomeProof &&
              selectedincomeProof
            )
          ) {
            setEnabledButton(false);
          } else {
            setEnabledButton(true);
          }
        }
      }
    }
  }, [frontBackForCA]);
  React.useEffect(() => {
    if (
      !(
        profileFile &&
        permantAddressFile &&
        permantAddressProof &&
        correspondenceAddressFile &&
        correspondenceAddressProof
      )
    ) {
      if (!childSr) {
        props.enableSubmit(false);
      } else {
        setEnabledButton(false);
      }
    } else {
      if (!childSr) {
        if (frontBack && !permantAddressFile2) {
          props.enableSubmit(false);
        }
        if (frontBackForCA && !correspondenceAddressFile2) {
          props.enableSubmit(false);
        } else {
          props.enableSubmit(true);
        }
      } else {
        if (
          !(
            isKraDetails() &&
            //bankFile &&
            incomeFile &&
            selectedSegincomeProof &&
            selectedincomeProof
          )
        ) {
          setEnabledButton(false);
        } else {
          setEnabledButton(true);
        }
      }
    }
  }, [
    profileFile,
    permantAddressFile,
    permantAddressProof,
    correspondenceAddressFile,
    correspondenceAddressProof,
  ]);
  React.useEffect(() => {
    if (
      !(
        profileFile &&
        permantAddressFile &&
        permantAddressProof &&
        correspondenceAddressFile &&
        correspondenceAddressProof &&
        //bankFile &&
        incomeFile &&
        selectedSegincomeProof &&
        selectedincomeProof &&
        isKraDetails()
      )
    ) {
      setEnabledButton(false);
    } else {
      setEnabledButton(true);
    }
  }, [
    //bankFile,
    incomeFile,
    kraDetails,
    selectedSegincomeProof,
    selectedincomeProof,
  ]);

  const btnEnableDisableProceed = (val: any) => {
    let isAllowed;
    if (!frontBack && !frontBackForCA) {
      isAllowed = val;
    } else {
      if (
        frontBack &&
        frontBackForCA &&
        permantAddressFile2 &&
        correspondenceAddressFile2
      ) {
        isAllowed = true;
      } else {
        if (frontBack && !frontBackForCA && permantAddressFile2) {
          isAllowed = true;
        } else {
          if (!frontBack && frontBackForCA && correspondenceAddressFile2) {
            isAllowed = true;
          } else {
            isAllowed = false;
          }
        }
      }
    }
    return isAllowed;
  };

  const isKraDetails = () => {
    let isAllowed;
    if (!srIdList.addressId) {
      return btnEnableDisableProceed(true);
    }
    if (
      JSON.stringify(kraDetails.webSign) !== "{}" &&
      JSON.stringify(kraDetails.panCard) !== "{}" &&
      childSr &&
      showHide.is_digilocker_flow
        ? true
        : JSON.stringify(kraDetails.photo) !== "{}"
    ) {
      if (
        JSON.stringify(kraDetails.panCard) === "{}" ||
        JSON.stringify(kraDetails.webSign) === "{}"
      ) {
        isAllowed = false;
      } else {
        isAllowed = true;
      }
    } else {
      isAllowed = false;
    }
    if (isAllowed) {
      isAllowed = btnEnableDisableProceed(isAllowed);
    }

    return isAllowed;
  };
  async function getMergeDocumentForPA(fileAttachements: any) {
    if (
      permantAddressFile &&
      permantAddressFile2 &&
      permantAddressFile.fileName &&
      permantAddressFile.fileData &&
      permantAddressFile2.fileName &&
      permantAddressFile2.fileData
    ) {
      // if (permantAddressFile.fileName.split(".")[1] === "pdf" && permantAddressFile2.fileName.split(".")[1] === "pdf") {
      //   fileAttachements.push({
      //     fileName: permantAddressFile.fileName,
      //     fileData: permantAddressFile.fileData,
      //     documentTypeName: permantAddressProof,
      //   });
      //   fileAttachements.push({
      //     fileName: permantAddressFile2.fileName,
      //     fileData: permantAddressFile2.fileData,
      //     documentTypeName: permantAddressProof,
      //   });
      // } else {
      let uploadImageObj = {
        applicationId: personalDetails?.accountCodeField
          ? personalDetails?.accountCodeField
          : accountCode,
        image1: permantAddressFile.fileData,
        image2: permantAddressFile2.fileData,
        imagename1: permantAddressFile.fileName,
        imagename2: permantAddressFile2.fileName,
      };
      try {
        let mergerResp = await getMergeDocumentBase64(uploadImageObj);
        if (mergerResp) {
          if (childSr) {
            return {
              fileName: "merge_document_PA.pdf",
              fileData: mergerResp,
              documentTypeName: permantAddressProof,
            };
          } else {
            if (fileAttachements) {
              fileAttachements.push({
                fileName: "merge_document_PA.pdf",
                fileData: mergerResp,
                documentTypeName: permantAddressProof,
              });
            }
          }
        }
        console.log(permantAddressFile.fileName);
      } catch (error) {
        //console.log(error);
        apiError();
      }
      //}
    } else {
      fileAttachements.push({
        fileName: permantAddressFile.fileName,
        fileData: permantAddressFile.fileData,
        documentTypeName: permantAddressProof,
      });
    }
  }
  async function getMergeDocumentForCA(fileAttachements: any) {
    if (
      correspondenceAddressFile &&
      correspondenceAddressFile2 &&
      correspondenceAddressFile.fileName &&
      correspondenceAddressFile.fileData &&
      correspondenceAddressFile2.fileName &&
      correspondenceAddressFile2.fileData
    ) {
      // if (correspondenceAddressFile.fileName.split(".")[1] === "pdf" && correspondenceAddressFile2.fileName.split(".")[1] === "pdf") {
      //   fileAttachements.push({
      //     fileName: correspondenceAddressFile.fileName,
      //     fileData: correspondenceAddressFile.fileData,
      //     documentTypeName: correspondenceAddressProof,
      //   });
      //   fileAttachements.push({
      //     fileName: correspondenceAddressFile2.fileName,
      //     fileData: correspondenceAddressFile2.fileData,
      //     documentTypeName: correspondenceAddressProof,
      //   });
      // } else {
      let uploadImageObj = {
        applicationId: personalDetails?.accountCodeField
          ? personalDetails?.accountCodeField
          : accountCode,
        image1: correspondenceAddressFile.fileData,
        image2: correspondenceAddressFile2.fileData,
        imagename1: correspondenceAddressFile.fileName,
        imagename2: correspondenceAddressFile2.fileName,
      };
      let mergerResp = await getMergeDocumentBase64(uploadImageObj);
      if (mergerResp) {
        if (childSr) {
          return {
            fileName: "merge_document_CA.pdf",
            fileData: mergerResp,
            documentTypeName: correspondenceAddressProof,
          };
        } else {
          if (fileAttachements) {
            fileAttachements.push({
              fileName: "merge_document_CA.pdf",
              fileData: mergerResp,
              documentTypeName: correspondenceAddressProof,
            });
          }
        }
      }
      //}
    } else {
      fileAttachements.push({
        fileName: correspondenceAddressFile.fileName,
        fileData: correspondenceAddressFile.fileData,
        documentTypeName: correspondenceAddressProof,
      });
    }
  }
  async function checkCKYCValidation() {
    try {
      let ckycValidateResp = false,
        ckycValidate = false;
      let ckycResp = await GetCKYCValidation();
      // let ckycValidation = await ServiceClientValidation({
      //   subtype: "CKYC Update",
      // });
      if (ckycResp) {
        if (ckycResp.match("No")) {
          ckycValidateResp = true;
        } else {
          ckycValidateResp = false;
          setExistingCKYCUpdateSR(ckycResp);
        }
        props.setLoader(false);
      }
      ckycValidate = true;
      // if (ckycValidation) {
      //   if (ckycValidation.match("BOAcoountNumber not found")) {
      //     ckycValidate = true;
      //   } else {
      //     ckycValidate = false;
      //     setExistingCKYCUpdateSR(ckycValidation);
      //   }
      //   props.setLoader(false);
      // }
      if (ckycValidateResp && ckycValidate) {
        setExistingCKYCUpdateSR("");
        props.showFooter(true);
      } else {
        props.showFooter(false);
      }
    } catch (error) {
      props.setLoader(false);
      apiError();
    }
  }
  function apiError() {
    props.onSubmit("createRequestApiError", {
      content:
        "There was some problem in raising service request. Please try again later.",
      headerText: "New Service Request",
    });
  }
  const handleSubmitForBank = (fileDetails: any) => {
    // setDropValChangedForBank(false);
    if (fileDetails && fileDetails.docFile && fileDetails.base64Data) {
      var actualbase64Data = fileDetails.base64Data.split(",");
      // setBankFile({
      //   fileName: fileDetails.docFile,
      //   fileData: actualbase64Data[1],
      // });
    } else {
      // setBankFile("");
    }
  };
  const handleSubmitForIncome = (fileDetails: any) => {
    if (fileDetails && fileDetails.docFile && fileDetails.base64Data) {
      var actualbase64Data = fileDetails.base64Data.split(",");
      setIncomeFile({
        fileName: fileDetails.docFile,
        base64Data: actualbase64Data[1],
      });
    } else {
      setIncomeFile("");
    }
  };
  const handleSubmitForProfile = (fileDetails: any) => {
    if (fileDetails && fileDetails.docFile && fileDetails.base64Data) {
      setProfileFile({
        fileName: fileDetails.docFile,
        fileData: fileDetails.base64Data.split(",")[1],
      });
    } else {
      setProfileFile(undefined);
    }
  };
  const handleSubmitForPermantAddressFile = (fileDetails: any) => {
    setDropValChangedPA(false);
    if (fileDetails && fileDetails.docFile && fileDetails.base64Data) {
      setPermantAddressFile({
        fileName: fileDetails.docFile,
        fileData: fileDetails.base64Data.split(",")[1],
      });
    } else {
      setPermantAddressFile("");
    }
  };
  const handleSubmitForPermantAddressFile2 = (fileDetails: any) => {
    setDropValChangedPA(false);
    if (fileDetails && fileDetails.docFile && fileDetails.base64Data) {
      setPermantAddressFile2({
        fileName: fileDetails.docFile,
        fileData: fileDetails.base64Data.split(",")[1],
      });
    } else {
      setFrontBack(false);
      setPermantAddressFile2("");
    }
  };

  const handleSubmitForCorrespondenceAddressFile = (fileDetails: any) => {
    setDropValChangedCA(false);
    if (fileDetails && fileDetails.docFile && fileDetails.base64Data) {
      setCorrespondenceFile({
        fileName: fileDetails.docFile,
        fileData: fileDetails.base64Data.split(",")[1],
      });
    } else {
      setCorrespondenceFile("");
    }
  };

  const handleSubmitForCorrespondenceAddressFile2 = (fileDetails: any) => {
    setDropValChangedCA(false);
    if (fileDetails && fileDetails.docFile && fileDetails.base64Data) {
      setcorrespondenceAddressFile2({
        fileName: fileDetails.docFile,
        fileData: fileDetails.base64Data.split(",")[1],
      });
    } else {
      setFrontBackForCA(false);
      setcorrespondenceAddressFile2("");
    }
  };
  function clearPermanentAddressFiles() {
    setPermantAddressFile(undefined);
    setPermantAddressFile2(undefined);
  }

  function returnAddressProofAccountReactivation(
    addressProof: any,
    isPermanent: boolean
  ) {
    if (!childSr) {
      return "";
    }
    if (addressProof && isPermanent) {
      return "AddressProof_P";
    } else {
      return "AddressProof_C";
    }
  }

  async function submitRequest() {
    props.setLoader(true);
    try {
      let fileAttachements: any = [];
      let addressProofForPermanent = "",
        addressProofForCA = "",
        mergedPA: any,
        mergedCA: any;
      addressProofForPermanent = permantAddressProof;
      addressProofForCA = correspondenceAddressProof;
      if (
        permantAddressFile &&
        permantAddressFile.fileName &&
        permantAddressFile.fileData &&
        addressProofForPermanent
      ) {
        if (addressProofForPermanent === "Aadhar") {
          let maskedObj = {
            proof: addressProofForPermanent,
            accountCode: personalDetails?.accountCodeField
              ? personalDetails?.accountCodeField
              : accountCode,
            fileData: permantAddressFile.fileData,
            fileName: permantAddressFile.fileName,
          };
          let respObj = await getMaskedAdhar(maskedObj, true);
          if (respObj.fileData && respObj.fileName) {
            permantAddressFile.fileData = respObj.fileData;
            permantAddressFile.fileName = respObj.fileName;
          } else {
            permantAddressFile.fileData = respObj;
          }
          if (
            permantAddressFile2 &&
            permantAddressFile2.fileName &&
            permantAddressFile2.fileData
          ) {
            maskedObj.fileName = permantAddressFile2.fileName;
            maskedObj.fileData = permantAddressFile2.fileData;
            let respObj = await getMaskedAdhar(maskedObj, true);
            if (respObj.fileData && respObj.fileName) {
              permantAddressFile2.fileData = respObj.fileData;
              permantAddressFile2.fileName = respObj.fileName;
            } else {
              permantAddressFile2.fileData = respObj;
            }
          }
        }
        mergedPA = await getMergeDocumentForPA(fileAttachements);
      }
      if (
        correspondenceAddressFile &&
        correspondenceAddressFile.fileName &&
        correspondenceAddressFile.fileData &&
        addressProofForCA
      ) {
        if (addressProofForCA === "Aadhar") {
          let maskedObj = {
            proof: addressProofForCA,
            accountCode: personalDetails?.accountCodeField
              ? personalDetails?.accountCodeField
              : accountCode,
            fileData: correspondenceAddressFile.fileData,
            fileName: correspondenceAddressFile.fileName,
          };
          let respObj = await getMaskedAdhar(maskedObj, true);
          if (respObj.fileData && respObj.fileName) {
            correspondenceAddressFile.fileData = respObj.fileData;
            correspondenceAddressFile.fileName = respObj.fileName;
          } else {
            correspondenceAddressFile.fileData = respObj;
          }
          if (
            correspondenceAddressFile2 &&
            correspondenceAddressFile2.fileName &&
            correspondenceAddressFile2.fileData
          ) {
            maskedObj.fileName = correspondenceAddressFile2.fileName;
            maskedObj.fileData = correspondenceAddressFile2.fileData;
            let respObj = await getMaskedAdhar(maskedObj, true);
            if (respObj.fileData && respObj.fileName) {
              correspondenceAddressFile2.fileData = respObj.fileData;
              correspondenceAddressFile2.fileName = respObj.fileName;
            } else {
              correspondenceAddressFile2.fileData = respObj;
            }
          }
        }
        mergedCA = await getMergeDocumentForCA(fileAttachements);
      }
      //if (childSr) await getAutoQCDetails();
      if (profileFile && profileFile.fileName && profileFile.fileData)
        fileAttachements.push({
          fileName: profileFile.fileName,
          fileData: profileFile.fileData,
          documentTypeName: "ProfilePhoto",
        });

      if (childSr) {
        // fileAttachements.push({
        //   // fileName: bankFile?.fileName,
        //   // fileData: bankFile?.fileData,
        //   documentTypeName: selectedSegincomeProof,
        // });
        fileAttachements.push({
          fileName: incomeFile.fileName,
          fileData: incomeFile.fileData,
          documentTypeName: selectedincomeProof,
        });
      }

      if (!childSr) {
        let reqObj: any;
        if (srID) {
          reqObj = [
            {
              serviceRequestId: Number(srID),
              AutoQC: "No",
              SRType: "CKYCChangeMode",
              attachment: fileAttachements,
            },
          ];
        } else {
          reqObj = {
            requestType: "CKYC Update",
            dpID: "none",
            fileAttaches: fileAttachements,
          };
        }
        // console.log(reqObj);
        if (srID) {
          let resp = await createSRDocumentUpload(reqObj);
          if (resp && resp === "All SR Details Updated successfully.") {
            props.setLoader(false);
            props.onSubmit("ckycUpdate", {
              content: "Your request will be updated within FIVE working days. Status of your request will be communicated through Email",
              headerText: "We have received your request",
              popupType: "Success"
            });
          }
        } else {
          let resp = await CreateServiceRequest(reqObj);
          if (
            typeof resp === "string" &&
            resp.includes("Previous Request already open for this account-")
          ) {
            openExistSrPopup();
            return;
          } else {
            if (resp.Message) {
              props.setLoader(false);
              props.onSubmit("ckycUpdate", {
                content: "Your request will be updated within FIVE working days. Status of your request will be communicated through Email",
                headerText: "We have received your request",
                popupType: "Success",
              });
            }
          }
        }
      } else {
        // let listBank;
        // if (newDataBank) {
        //   // newDataBank.autoQc = srIdList.bankQc;
        //   listBank = allBank.map((bank: any) => {
        //     delete bank.received_proof;
        //     delete bank.qc_flag;
        //     delete bank.received_proof;

        //     if (bank.new_bank_details) {
        //       const NewBankDetails = bank.new_bank_details;
        //       delete bank.new_bank_details;

        //       return {
        //         ...bank,
        //         NewBankDetails,
        //       };
        //     } else {
        //       return bank;
        //     }
        //   });
        //   //  console.log(allBank);
        // }

        let reqObj: any = [
          {
            serviceRequestId: Number(props.srId),
            attachment: null,
            SRType: "ParentWithSR",
          },
        ];
        if (rejectFlow) {
          reqObj[0].SRType = null;
        }

        if (!showHide.ckycStatus && showHide.is_digilocker_flow) {
          console.log("ckyc", digDoc);
          let request = {
            serviceRequestId: Number(srIdList.ckycId),
            AutoQC: "NA",
            SRType: rejectFlow ? "CKYCChangeModeDocument" : "CKYC",
            attachment: [
              {
                fileName: profileFile.fileName,
                fileData: profileFile.fileData,
                documentTypeName: "Photograph",
              },
            ],
          };
          if (
            !rejectFlow &&
            digDoc &&
            digDoc.fileName &&
            digDoc.fileData &&
            digDoc.documentTypeName
          )
            request.attachment.push(
              ...(showHide.sameAsPermanent
                ? [
                    {
                      fileName: digDoc.fileName,
                      fileData: digDoc.fileData,
                      documentTypeName: digDoc.documentTypeName,
                    },
                  ]
                : [
                    {
                      fileName: digDoc.fileName,
                      fileData: digDoc.fileData,
                      documentTypeName: digDoc.documentTypeName,
                    },
                    {
                      fileName: digDoc.fileName,
                      fileData: digDoc.fileData,
                      documentTypeName: digDoc.documentTypeName,
                    },
                  ])
            );

          reqObj.push(request);

          if (srIdList.addressId) {
            reqObj.push({
              serviceRequestId: Number(srIdList.addressId),
              AutoQC: srIdList.addressQc,
              SRType: rejectFlow ? "AddressChangeModeDocument" : "Address",
              attachment: [
                {
                  fileName: kraDetails.webSign?.fileName,
                  fileData: kraDetails.webSign?.fileData,
                  documentTypeName: kraDetails.webSign?.documentTypeName,
                },
                {
                  fileName: kraDetails.panCard?.fileName,
                  fileData: kraDetails.panCard?.fileData,
                  documentTypeName: kraDetails.panCard?.documentTypeName,
                },
                // {
                //   fileName: photoDigiLoc.fileName,
                //   fileData: photoDigiLoc.fileData,
                //   documentTypeName: photoDigiLoc.documentTypeName,
                // }
              ],
            });
          }
        } else if (!showHide.ckycStatus && !showHide.is_digilocker_flow) {
          //  console.log("ckyc", "!digie");

          let obj = {
            serviceRequestId: Number(srIdList.ckycId),
            AutoQC: srIdList.addressQc,
            SRType: rejectFlow ? "CKYCChangeModeDocument" : "CKYC",
            attachment: [
              ...(showHide.sameAsPermanent
                ? [
                    {
                      fileName:
                        mergedPA && mergedPA.fileName
                          ? mergedPA.fileName
                          : permantAddressFile.fileName,
                      fileData:
                        mergedPA && mergedPA.fileData
                          ? mergedPA.fileData
                          : permantAddressFile.fileData,
                      documentTypeName: returnAddressProofAccountReactivation(
                        addressProofForPermanent,
                        true
                      ),
                    },
                  ]
                : [
                    {
                      fileName:
                        mergedPA && mergedPA.fileName
                          ? mergedPA.fileName
                          : permantAddressFile.fileName,
                      fileData:
                        mergedPA && mergedPA.fileData
                          ? mergedPA.fileData
                          : permantAddressFile.fileData,
                      documentTypeName: returnAddressProofAccountReactivation(
                        addressProofForPermanent,
                        true
                      ),
                    },
                    {
                      fileName:
                        mergedCA && mergedCA.fileName
                          ? mergedCA.fileName
                          : correspondenceAddressFile.fileName,
                      fileData:
                        mergedCA && mergedCA.fileData
                          ? mergedCA.fileData
                          : correspondenceAddressFile.fileData,
                      documentTypeName: returnAddressProofAccountReactivation(
                        addressProofForCA,
                        false
                      ),
                    },
                  ]),
              {
                fileName: profileFile.fileName,
                fileData: profileFile.fileData,
                documentTypeName: "Photograph",
              },
            ],
          };

          if (!srIdList.addressId) {
            if(kraDetails.webSign && kraDetails.webSign.fileName && kraDetails.webSign.fileData && kraDetails.webSign.documentTypeName){
              obj.attachment.push({
                fileName: kraDetails.webSign?.fileName,
                fileData: kraDetails.webSign?.fileData,
                documentTypeName: kraDetails.webSign?.documentTypeName,
              });
            }
            if(kraDetails.panCard && kraDetails.panCard.fileName && kraDetails.panCard.fileData && kraDetails.panCard.documentTypeName){
              obj.attachment.push({
                fileName: kraDetails.panCard?.fileName,
                fileData: kraDetails.panCard?.fileData,
                documentTypeName: kraDetails.panCard?.documentTypeName,
              });
            } 
            if(kraDetails.photo && kraDetails.photo.fileName && kraDetails.photo.fileData && kraDetails.photo.documentTypeName){
              obj.attachment.push({
                fileName: kraDetails.photo?.fileName,
                fileData: kraDetails.photo?.fileData,
                documentTypeName: kraDetails.photo?.documentTypeName,
              });    
            }       
          }

          reqObj.push(obj);
          if (srIdList.addressId)
            reqObj.push({
              serviceRequestId: Number(srIdList.addressId),
              AutoQC: srIdList.addressQc,
              SRType: rejectFlow ? "AddressChangeModeDocument" : "Address",
              attachment: [
                ...(showHide.sameAsPermanent
                  ? [
                      {
                        fileName:
                          mergedPA && mergedPA.fileName
                            ? mergedPA.fileName
                            : permantAddressFile.fileName,
                        fileData:
                          mergedPA && mergedPA.fileData
                            ? mergedPA.fileData
                            : permantAddressFile.fileData,
                        documentTypeName: returnAddressProofAccountReactivation(
                          addressProofForPermanent,
                          true
                        ),
                      },
                      {
                        fileName: kraDetails.webSign?.fileName,
                        fileData: kraDetails.webSign?.fileData,
                        documentTypeName: kraDetails.webSign?.documentTypeName,
                      },
                      {
                        fileName: kraDetails.panCard?.fileName,
                        fileData: kraDetails.panCard?.fileData,
                        documentTypeName: kraDetails.panCard?.documentTypeName,
                      },
                      {
                        fileName: kraDetails.photo?.fileName,
                        fileData: kraDetails.photo?.fileData,
                        documentTypeName: kraDetails.photo?.documentTypeName,
                      },
                    ]
                  : [
                      {
                        fileName:
                          mergedPA && mergedPA.fileName
                            ? mergedPA.fileName
                            : permantAddressFile.fileName,
                        fileData:
                          mergedPA && mergedPA.fileData
                            ? mergedPA.fileData
                            : permantAddressFile.fileData,
                        documentTypeName: returnAddressProofAccountReactivation(
                          addressProofForPermanent,
                          true
                        ),
                      },
                      {
                        fileName:
                          mergedCA && mergedCA.fileName
                            ? mergedCA.fileName
                            : correspondenceAddressFile.fileName,
                        fileData:
                          mergedCA && mergedCA.fileData
                            ? mergedCA.fileData
                            : correspondenceAddressFile.fileData,
                        documentTypeName: returnAddressProofAccountReactivation(
                          addressProofForCA,
                          false
                        ),
                      },
                      {
                        fileName: kraDetails.webSign?.fileName,
                        fileData: kraDetails.webSign?.fileData,
                        documentTypeName: kraDetails.webSign?.documentTypeName,
                      },
                      {
                        fileName: kraDetails.panCard?.fileName,
                        fileData: kraDetails.panCard?.fileData,
                        documentTypeName: kraDetails.panCard?.documentTypeName,
                      },
                      {
                        fileName: kraDetails.photo?.fileName,
                        fileData: kraDetails.photo?.fileData,
                        documentTypeName: kraDetails.photo?.documentTypeName,
                      },
                    ]),
              ],
            });
        } else if (showHide.ckycStatus && !showHide.is_digilocker_flow) {
          reqObj.push({
            serviceRequestId: Number(srIdList.addressId),
            AutoQC: srIdList.addressQc,
            SRType: rejectFlow ? "AddressChangeModeDocument" : "Address",
            attachment: [
              ...(showHide.sameAsPermanent
                ? [
                    {
                      fileName:
                        mergedPA && mergedPA.fileName
                          ? mergedPA.fileName
                          : permantAddressFile.fileName,
                      fileData:
                        mergedPA && mergedPA.fileData
                          ? mergedPA.fileData
                          : permantAddressFile.fileData,
                      documentTypeName: returnAddressProofAccountReactivation(
                        addressProofForPermanent,
                        true
                      ),
                    },
                    {
                      fileName: kraDetails.webSign?.fileName,
                      fileData: kraDetails.webSign?.fileData,
                      documentTypeName: kraDetails.webSign?.documentTypeName,
                    },
                    {
                      fileName: kraDetails.panCard?.fileName,
                      fileData: kraDetails.panCard?.fileData,
                      documentTypeName: kraDetails.panCard?.documentTypeName,
                    },
                    {
                      fileName: kraDetails.photo?.fileName,
                      fileData: kraDetails.photo?.fileData,
                      documentTypeName: kraDetails.photo?.documentTypeName,
                    },
                  ]
                : [
                    {
                      fileName:
                        mergedPA && mergedPA.fileName
                          ? mergedPA.fileName
                          : permantAddressFile.fileName,
                      fileData:
                        mergedPA && mergedPA.fileData
                          ? mergedPA.fileData
                          : permantAddressFile.fileData,
                      documentTypeName: returnAddressProofAccountReactivation(
                        addressProofForPermanent,
                        true
                      ),
                    },
                    {
                      fileName:
                        mergedCA && mergedCA.fileName
                          ? mergedCA.fileName
                          : correspondenceAddressFile.fileName,
                      fileData:
                        mergedCA && mergedCA.fileData
                          ? mergedCA.fileData
                          : correspondenceAddressFile.fileData,
                      documentTypeName: returnAddressProofAccountReactivation(
                        addressProofForCA,
                        false
                      ),
                    },
                    {
                      fileName: kraDetails.webSign?.fileName,
                      fileData: kraDetails.webSign?.fileData,
                      documentTypeName: kraDetails.webSign?.documentTypeName,
                    },
                    {
                      fileName: kraDetails.panCard?.fileName,
                      fileData: kraDetails.panCard?.fileData,
                      documentTypeName: kraDetails.panCard?.documentTypeName,
                    },
                    {
                      fileName: kraDetails.photo?.fileName,
                      fileData: kraDetails.photo?.fileData,
                      documentTypeName: kraDetails.photo?.documentTypeName,
                    },
                  ]),
            ],
          });
        } else if (showHide.ckycStatus && showHide.is_digilocker_flow) {
          if (srIdList.addressId) {
            reqObj.push({
              serviceRequestId: Number(srIdList.addressId),
              AutoQC: srIdList.addressQc,
              SRType: rejectFlow ? "AddressChangeModeDocument" : "Address",
              attachment: [
                {
                  fileName: kraDetails.webSign?.fileName,
                  fileData: kraDetails.webSign?.fileData,
                  documentTypeName: kraDetails.webSign?.documentTypeName,
                },
                {
                  fileName: kraDetails.panCard?.fileName,
                  fileData: kraDetails.panCard?.fileData,
                  documentTypeName: kraDetails.panCard?.documentTypeName,
                },
              ],
            });
          }
        }

        let resp = await createSRDocumentUpload(reqObj);
       
        if (
          resp &&
          (resp === "Document uploaded successfully." ||
            resp === "All SR Details Updated successfully.")
        ) {
          props.next();
          return;
        } else {
          props.setLoader(false);
          props.onSubmit("createRequestApiError", {
            content:
              "There was some problem in raising service request. Please try again later.",
            headerText: "New Service Request",
          });
        }
      }
    } catch (error) {
      console.log(error);
      props.setLoader(false);
      props.onSubmit("createRequestApiError", {
        content:
          "There was some problem in raising service request. Please try again later.",
        headerText: "New Service Request",
      });
    }
  }
  useImperativeHandle(ref, () => ({
    submitData() {
      submitRequest();
    },
  }));
  const openExistSrPopup = () => {
    props.setLoader(false);
    props.onSubmit("ckycUpdate", {
      headerText: "You have an active service request",
      content:
        "You already have an active service request. Once it is updated, you will be able to raise new request.",
    });
  };
  return (
    <div className="ckycUpdate-wrap">
      {/* {loader && (
        <div
          style={{
            textAlign: "center",
            paddingTop: "50px",
            paddingBottom: "50px",
          }}
        >
          <Loader size={50} color="blue"></Loader>
        </div>
      )} */}
      {!props.loader && (
        <div>
          {existingCKYCUpdateSR && (
            <div className="inProgress_wrap">
              <div className="inProgress">
                <div className="inProgress__dots">
                  <div className="dot1 dot-active"></div>
                  <div className="dot2"></div>
                  <div className="dot3"></div>
                </div>
              </div>
              <div className="">
                <p className="field-head text-center">CKYC under Process</p>
                <p className="field-subHead desc text-center grey-text">
                  {existingCKYCUpdateSR}
                </p>
              </div>
            </div>
          )}
          {!existingCKYCUpdateSR && (
            <div>
              {personalDetails && !childSr && (
                <div className="custom--row incomeMsg--row">
                  <div className="form-field custom-col">
                    <label className="input-label">Account Code</label>
                    <InputField
                      onChange={(value) => {}}
                      defaultValue={personalDetails.accountCodeField}
                      onBlur={(error) => {}}
                      className="formInpCont mgT7"
                      placeholder=""
                      maxLength={10}
                      required
                      type="text"
                      disabled={true}
                      helpTextColor="blue"
                    />
                  </div>
                  <div className="form-field custom-col-1">
                    <label className="input-label">Pan Number</label>
                    <InputField
                      onChange={(value) => {}}
                      defaultValue={personalDetails.pANNumberField}
                      onBlur={(error) => {}}
                      className="formInpCont mgT7"
                      placeholder=""
                      maxLength={10}
                      required
                      type="text"
                      disabled={true}
                      helpTextColor="blue"
                    />
                  </div>
                </div>
              )}

              {childSr && showHide && !showHide.ckycStatus && (
                <div className="custom-row profilePhoto">
                  <label className="incomeMsg bold-text">Profile Photo</label>
                  <p className="ei-text">Scanned Copy Of Passport size photo</p>
                  <FileUploadSection
                    disableCross={false}
                    fileType={["pdf", "jpg", "jpeg", "tif", "tiff"]}
                    onSubmit={handleSubmitForProfile}
                    // dropValChanged={dropValChanged}
                    fileName={profileFile?.fileName ? profileFile.fileName : ""}
                  />
                  {!(profileFile && profileFile.fileName) && (
                    <p className="text-indicator small--text-indicator noSpaceIndicator">
                      Kindly upload clear and coloured images of original
                      documents of proof of Identity
                    </p>
                  )}
                </div>
              )}
              {!childSr && (
                <div className="custom-row profilePhoto">
                  <label className="incomeMsg bold-text">Profile Photo</label>
                  <p className="ei-text">Scanned Copy Of Passport size photo</p>
                  <FileUploadSection
                    disableCross={false}
                    fileType={["pdf", "jpg", "jpeg", "tif", "tiff"]}
                    onSubmit={handleSubmitForProfile}
                    fileName={profileFile?.fileName ? profileFile.fileName : ""}
                    // dropValChanged={dropValChanged}
                  />
                  {!(profileFile && profileFile.fileName) && (
                    <p className="text-indicator small--text-indicator noSpaceIndicator">
                      Kindly upload clear and coloured images of original
                      documents of proof of Identity
                    </p>
                  )}
                </div>
              )}

              {showHide && !showHide.is_digilocker_flow && (
                <div>
                  {!childSr &&
                    personalDetails &&
                    personalDetails.addressField && (
                      <div>
                        <h6 className="field-subHead bold-text">
                          Permanent{" "}
                          {showHide.sameAsPermanent
                            ? "and Correspondence "
                            : ""}
                          Address
                        </h6>
                        {!childSr && (
                          <div className="">
                            <p className="field-subHead grey-text small-text">
                              Different Address?
                              <a
                                href={
                                  config.root +
                                  "clientarea/service-request/address-modification"
                                }
                              >
                                {" "}
                                Click here
                              </a>{" "}
                              to modify address.
                            </p>
                          </div>
                        )}
                        <p className="field-subHead">
                          {personalDetails.addressField}
                        </p>
                      </div>
                    )}
                  <div
                    className={
                      childSr && showHide && showHide.ckycStatus
                        ? "custom-row-SR"
                        : showHide.sameAsPermanent
                        ? "custom-row custom-row-front-back"
                        : "custom-row permanentAddrRow"
                    }
                  >
                    <label className="incomeMsg bold-text">
                      Permanent Address Proof
                    </label>
                    <p className="ei-text">Scanned Copy Of Address Proof</p>
                    <div className="form-field custom-col-1">
                      <TocDropdown
                        selectedValue={
                          permantAddressProof
                            ? permantAddressProof
                            : childSr
                            ? addressChildProofOptions[0].value
                            : addressProofOptions[0].value
                        }
                        dropdownOptions={
                          childSr
                            ? addressChildProofOptions
                              ? addressChildProofOptions
                              : []
                            : addressProofOptions
                            ? addressProofOptions
                            : []
                        }
                        onSelect={(value) => {
                          setPermantAddressProof(value);
                          setDropValChangedPA(true);
                          setFrontBack(frontBack);
                          clearPermanentAddressFiles();
                        }}
                        isSearchable={false}
                      />
                    </div>
                    <FileUploadSection
                      disableCross={false}
                      fileType={["pdf", "jpg", "jpeg", "tif", "tiff"]}
                      onSubmit={handleSubmitForPermantAddressFile}
                      dropValChanged={dropValChangedForPA}
                      fileName={
                        permantAddressFile?.fileName
                          ? permantAddressFile.fileName
                          : ""
                      }
                      secondFileName={
                        frontBack &&
                        permantAddressFile2 &&
                        permantAddressFile2.fileName
                          ? permantAddressFile2.fileName
                          : ""
                      }
                    />
                    {frontBack && (
                      <FileUploadSection
                        disableCross={false}
                        fileType={["pdf", "jpg", "jpeg", "tif", "tiff"]}
                        onSubmit={handleSubmitForPermantAddressFile2}
                        dropValChanged={dropValChangedForPA}
                        secondFileName={
                          frontBack &&
                          permantAddressFile &&
                          permantAddressFile.fileName
                            ? permantAddressFile.fileName
                            : ""
                        }
                      />
                    )}
                  </div>
                  <div>
                    <p className="text-indicator small--text-indicator noSpaceIndicatorr">
                      If you want to update address as per aadhar, please
                      process from digilocker
                    </p>
                    {frontBack ? (
                      <div>
                        {!(
                          permantAddressFile &&
                          permantAddressFile.fileName &&
                          permantAddressFile2 &&
                          permantAddressFile2.fileName
                        ) && (
                          <>
                            <p className="text-indicator small--text-indicator noSpaceIndicator">
                              Kindly upload clear and coloured images of
                              original documents of proof of Address
                            </p>
                            {permantAddressProof &&
                              permantAddressProof === "Aadhar" && (
                                <p className="text-indicator small--text-indicator noSpaceIndicator">
                                  If you are uploading your Aadhaar Card, please
                                  ensure that the Aadhaar No. is masked (only
                                  last 4 digits to be visible).
                                </p>
                              )}
                          </>
                        )}
                      </div>
                    ) : (
                      <div>
                        {!(
                          permantAddressFile && permantAddressFile.fileName
                        ) && (
                          <>
                            <p className="text-indicator small--text-indicator noSpaceIndicator">
                              Kindly upload clear and coloured images of
                              original documents of proof of Address
                            </p>
                            {permantAddressProof &&
                              permantAddressProof === "Aadhar" && (
                                <p className="text-indicator small--text-indicator noSpaceIndicator">
                                  If you are uploading your Aadhaar Card, please
                                  ensure that the Aadhaar No. is masked (only
                                  last 4 digits to be visible).
                                </p>
                              )}
                          </>
                        )}
                      </div>
                    )}
                  </div>
                  <div>
                    {!frontBack && (
                      <button
                        type="button"
                        className="ed_button common_button noBg-btn"
                      >
                        <span className="edel-icon-plus"></span>
                        <span
                          onClick={() => {
                            setFrontBack(true);
                          }}
                        >
                          Add Front/Back Document
                        </span>
                      </button>
                    )}
                    {frontBack && (
                      <button
                        type="button"
                        className="ed_button common_button noBg-btn"
                      >
                        <span className="edel-icon-minus"></span>
                        <span
                          onClick={() => {
                            setFrontBack(false);
                          }}
                        >
                          Remove Front/Back Document
                        </span>
                      </button>
                    )}
                  </div>
                  {!childSr &&
                    personalDetails &&
                    personalDetails.currentAddressField &&
                    !showHide.sameAsPermanent && (
                      <div>
                        <h6 className="field-subHead bold-text">
                          Correspondence Address
                        </h6>
                        <p className="field-subHead">
                          {personalDetails.currentAddressField}
                        </p>
                      </div>
                    )}
                  {!showHide.sameAsPermanent && (
                    <>
                      <div className="custom-row">
                        <label className="incomeMsg bold-text">
                          Correspondence Address Proof
                        </label>
                        <p className="ei-text">Scanned Copy Of Address Proof</p>
                        <div className="form-field custom-col-1">
                          <TocDropdown
                            selectedValue={
                              correspondenceAddressProof
                                ? correspondenceAddressProof
                                : childSr
                                ? addressChildProofOptions[0].value
                                : addressProofOptions[0].value
                            }
                            dropdownOptions={
                              childSr
                                ? addressChildProofOptions
                                  ? addressChildProofOptions
                                  : []
                                : addressProofOptions
                                ? addressProofOptions
                                : []
                            }
                            onSelect={(value) => {
                              setCorrespondenceAddressProof(value);
                              setDropValChangedCA(true);
                              setFrontBackForCA(frontBackForCA);
                              setCorrespondenceFile(undefined);
                              setcorrespondenceAddressFile2(undefined);
                            }}
                            isSearchable={false}
                          />
                        </div>
                        <FileUploadSection
                          disableCross={false}
                          fileType={["pdf", "jpg", "jpeg", "tif", "tiff"]}
                          onSubmit={handleSubmitForCorrespondenceAddressFile}
                          dropValChanged={dropValChangedForCA}
                          fileName={correspondenceAddressFile?.fileName}
                          secondFileName={
                            frontBackForCA &&
                            correspondenceAddressFile2 &&
                            correspondenceAddressFile2.fileName
                              ? correspondenceAddressFile2.fileName
                              : ""
                          }
                        />
                        {frontBackForCA && (
                          <FileUploadSection
                            disableCross={false}
                            fileType={["pdf", "jpg", "jpeg", "tif", "tiff"]}
                            onSubmit={handleSubmitForCorrespondenceAddressFile2}
                            dropValChanged={dropValChangedForCA}
                            secondFileName={
                              frontBackForCA &&
                              correspondenceAddressFile &&
                              correspondenceAddressFile.fileName
                                ? correspondenceAddressFile.fileName
                                : ""
                            }
                          ></FileUploadSection>
                        )}
                      </div>
                      <div>
                        <p className="text-indicator small--text-indicator noSpaceIndicatorr">
                          If you want to update address as per aadhar, please
                          process from digilocker
                        </p>
                        {frontBackForCA ? (
                          <div>
                            {!(
                              correspondenceAddressFile &&
                              correspondenceAddressFile.fileName &&
                              correspondenceAddressFile2 &&
                              correspondenceAddressFile2.fileName
                            ) && (
                              <>
                                <p className="text-indicator small--text-indicator noSpaceIndicator">
                                  Kindly upload clear and coloured images of
                                  original documents of proof of Address
                                </p>
                                {correspondenceAddressProof &&
                                  correspondenceAddressProof === "Aadhar" && (
                                    <p className="text-indicator small--text-indicator noSpaceIndicator">
                                      If you are uploading your Aadhaar Card,
                                      please ensure that the Aadhaar No. is
                                      masked (only last 4 digits to be visible).
                                    </p>
                                  )}
                              </>
                            )}
                          </div>
                        ) : (
                          <div>
                            {!(
                              correspondenceAddressFile &&
                              correspondenceAddressFile.fileName
                            ) && (
                              <>
                                <p className="text-indicator small--text-indicator noSpaceIndicator">
                                  Kindly upload clear and coloured images of
                                  original documents of proof of Address
                                </p>
                                {/* {correspondenceAddressProof &&
                                  correspondenceAddressProof === "Aadhar" && (
                                    <p className="text-indicator small--text-indicator noSpaceIndicator">
                                      If you are uploading your Aadhaar Card,
                                      please ensure that the Aadhaar No. is
                                      masked (only last 4 digits to be visible).
                                    </p>
                                  )} */}
                              </>
                            )}
                          </div>
                        )}
                      </div>
                      <div>
                        {!frontBackForCA && (
                          <button
                            type="button"
                            className="ed_button common_button noBg-btn"
                          >
                            <span className="edel-icon-plus"></span>
                            <span
                              onClick={() => {
                                setFrontBackForCA(true);
                              }}
                            >
                              Add Front/Back Document
                            </span>
                          </button>
                        )}
                        {frontBackForCA && (
                          <button
                            type="button"
                            className="ed_button common_button noBg-btn"
                          >
                            <span className="edel-icon-minus"></span>
                            <span
                              onClick={() => {
                                setFrontBackForCA(false);
                              }}
                            >
                              Remove Front/Back Document
                            </span>
                          </button>
                        )}
                      </div>
                    </>
                  )}
                </div>
              )}
              {!childSr && (
                <>
                  <p className="text-indicator small--text-indicator noSpaceIndicator">
                    The changes mentioned will be applicable for your Trading
                    and Default Demat account
                  </p>
                </>
              )}
              {childSr && showHide && srIdList.addressId && (
                <KRADocumentUploadForm
                  kraDetails={kraDetails}
                  setKraDetails={setKraDetails}
                  hidePhoto={
                    showHide && showHide.is_digilocker_flow ? true : false
                  }
                ></KRADocumentUploadForm>
              )}
              {childSr && (
                <>
                  {/* {showHide && !showHide.pennyDrop && (
                    <>
                      <div className="bank_proof__text">
                        <label className="input-label input-label--head">
                          Bank Proof{" "}
                        </label>
                        <p className="ei-text">
                          Scanned copy of Bank proof for account. <br />
                          Document should have your Name, Account Number, IFSC
                          and MICR code clearly visible
                        </p>
                      </div>
                      <div>
                        <div className="custom--row">
                          <div className="custom-col">
                            <TocDropdown
                              selectedValue={
                                selectedSegincomeProof
                                  ? selectedSegincomeProof
                                  : bankDropdownMenu[0].value
                              }
                              dropdownOptions={
                                bankDropdownMenu ? bankDropdownMenu : []
                              }
                              onSelect={(value) => {
                                setSelectedSegincomeProof(value);
                                setDropValChangedForBank(true);
                                setBankFile(undefined);
                              }}
                              isSearchable={false}
                            />
                          </div>
                          <div className="custom-col"></div>
                        </div>

                        <FileUploadSection
                          disableCross={false}
                          fileType={["tif", "tiff", "pdf", "jpg", "jpeg"]}
                          onSubmit={handleSubmitForBank}
                          dropValChanged={dropValChangedForBank}
                          fileName={bankFile?.fileName}
                        />
                        {!(bankFile && bankFile.fileName) && (
                          <p className="text-indicator small--text-indicator noSpaceIndicator">
                            Kindly upload clear and coloured images of original
                            documents of proof of bank
                          </p>
                        )}
                      </div>
                    </>
                  )} */}

                  {showHide && !showHide.showIncome && (
                    <>
                      <div>
                        <h6 className="input-label input-label--head">
                          Income Proof
                        </h6>
                        <p className="sub-text">
                          Scanned copy of income proof (Max size 1Mb)
                        </p>
                      </div>
                      <div>
                        <div className="custom--row">
                          <div className="custom-col">
                            <TocDropdown
                              selectedValue={
                                selectedincomeProof
                                  ? selectedincomeProof
                                  : bankDropdownMenu[0].value
                              }
                              dropdownOptions={
                                segincomeProof ? segincomeProof : []
                              }
                              onSelect={(value) => {
                                setSelectedincomeProof(value);
                                setDropValChangedForIncome(true);
                              }}
                              isSearchable={false}
                            />
                          </div>
                          <div className="custom-col"></div>
                        </div>

                        <FileUploadSection
                          disableCross={false}
                          fileType={["tif", "tiff", "pdf", "jpg", "jpeg"]}
                          onSubmit={handleSubmitForIncome}
                          dropValChanged={dropValChangedForIncome}
                        />
                      </div>
                    </>
                  )}
                  <div className="modal-footer common-modal--footer">
                    <div className="mob-center">
                      <button
                        type="button"
                        className="btn btn-blue login-btn"
                        disabled={!enabledButton}
                        onClick={() => submitRequest()}
                      >
                        {childSr ? "Proceed" : "Submit"}
                      </button>
                      <button
                        type="submit"
                        disabled={
                          (consentType &&
                            (consentType?.includes("email") ||
                              consentType?.includes("mobile") ||
                              consentType?.includes("emailMob"))) ||
                          addressConsent?.includes("Change of Address")
                            ? true
                            : false
                        }
                        className="btn btn-olink login-btn"
                      >
                        {!(
                          (consentType &&
                            (consentType?.includes("email") ||
                              consentType?.includes("mobile") ||
                              consentType?.includes("emailMob"))) ||
                          addressConsent?.includes("Change of Address")
                        ) && (
                          <a
                            className="btn btn-olink login-btn"
                            href={
                              window.location.href.includes("ajs")
                                ? config.rootUrl + "clientarea/servicerequest"
                                : config.root + "/clientarea/service-request"
                            }
                          >
                            Cancel
                          </a>
                        )}
                        {((consentType &&
                          (consentType?.includes("email") ||
                            consentType?.includes("mobile") ||
                            consentType?.includes("emailMob"))) ||
                          addressConsent?.includes("Change of Address")) && (
                          <label className="btn btn-olink login-btn">
                            Cancel
                          </label>
                        )}
                      </button>
                    </div>
                  </div>
                </>
              )}
            </div>
          )}
        </div>
      )}
    </div>
  );
});
